import { Box, IconButton, Typography } from "@mui/material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import FavoriteIcon from "@mui/icons-material/Favorite";
import TitreTypography from "../Typography/TitreTypography";
import SousTitreTypography from "../Typography/SousTitreTypography";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Lovely } from "../../image/icons/lovely.svg";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
function BarUploadProduct({
  titre,
  sousTitre,
  beforeOnClik,
  LovelyIcon = true,
}) {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      padding={1}
    >
      {/* Left: arrow + text */}
      <Box display="flex" alignItems="center" gap={1}>
        <IconButton
          sx={{
            width: 44,
            height: 44,
            borderRadius: "16px",
            backgroundColor: "#FFFFFF",
            opacity: 1,
            "&:hover": { backgroundColor: "#F0F0F0" },
          }}
          onClick={beforeOnClik}
        >
          <ArrowLeftIcon sx={{ color: "#292D32", fontSize: "38px" }} />
        </IconButton>

        <Box>
          <SousTitreTypography>{sousTitre}</SousTitreTypography>

          <Typography
            sx={{
              fontFamily: "F37 Ginger, sans-serif",
              fontWeight: 700, // Bold = 700
              fontStyle: "normal", // "Bold" غير صالح في CSS
              fontSize: "18px",
              lineHeight: "22px", // كما طلبت
              letterSpacing: "0px",
              verticalAlign: "bottom", // مفيد فقط إذا العنصر inline
              color: "#32324D",
            }}
          >
            {titre}
          </Typography>
        </Box>
      </Box>

      {/* Right: favorite icon */}
      <IconButton
        sx={{
          width: 44,
          height: 44,
          borderRadius: "16px",
          backgroundColor: "#FFFFFF",
          opacity: 1,
          "&:hover": { backgroundColor: "#F0F0F0" },
        }}
      >
        {LovelyIcon ? (
          <Lovely style={{ width: 24, height: 24 }} />
        ) : (
          <FavoriteBorderIcon sx={{ color: "black" }} />
        )}
      </IconButton>
    </Box>
  );
}

export default BarUploadProduct;
